/**
 * Design Tokens: Typography
 *
 * Montserrat e a fonte oficial do sistema.
 */

export const fontFamilies = {
  montserrat: {
    value: 'Montserrat, sans-serif',
    label: 'Montserrat',
  },
};

export const fontSizes = {
  mini: {
    value: '0.75rem',
    label: 'Mini',
  },
  small: {
    value: '0.875rem',
    label: 'Pequeno',
  },
  medium: {
    value: '0.9375rem',
    label: 'Medio',
  },
  large: {
    value: '1rem',
    label: 'Grande',
  },
};

export const typography = {
  light: {
    fontFamily: fontFamilies.montserrat.value,
    fontSize: fontSizes.large.value,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 700,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontSize: '0.95rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.5,
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.75,
      textTransform: 'uppercase',
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: 1.66,
    },
  },
  dark: {},
  moonstone: {},
  sepia: {},
};

const typographyTokens = {
  fontFamilies,
  fontSizes,
  typography,
};

export default typographyTokens;
